import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const MaintenancePage = ({ maintenanceMessage }) => {
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    const defaultMessage = "The system is currently under maintenance. Please come back later. Contact itsupport@csimaverick.com if the issue persists.";

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
                {/* Maintenance Icon */}
                <div className="mb-6">
                    <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                        <svg 
                            className="w-8 h-8 text-yellow-600" 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                        >
                            <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth="2" 
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                            />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-bold text-gray-900 mb-4">
                    System Under Maintenance
                </h1>

                {/* Message */}
                <p className="text-gray-600 mb-6 leading-relaxed">
                    {maintenanceMessage || defaultMessage}
                </p>

                {/* Actions */}
                <div className="space-y-3">
                    <button
                        onClick={() => window.location.reload()}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
                    >
                        Refresh Page
                    </button>
                    
                    <button
                        onClick={handleLogout}
                        className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-4 rounded-lg transition-colors duration-200"
                    >
                        Logout
                    </button>
                </div>

                {/* Footer */}
                <div className="mt-8 pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Maverick Cursor Analytics
                    </p>
                    <p className="text-xs text-gray-400 mt-1">
                        We'll be back shortly
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
